/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateNewQuickcheckClientRequest
 */
export interface CreateNewQuickcheckClientRequest {
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    company?: string;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    serviceproviderUUID?: string;
    /**
     * 
     */
    phone?: string;
    /**
     * Optional Cloudflare Turnstile token. When present, it is verified against Cloudflare before the request is processed.
     */
    turnstileToken?: string;
}

/**
 * Check if a given object implements the CreateNewQuickcheckClientRequest interface.
 */
export function instanceOfCreateNewQuickcheckClientRequest(value: object): value is CreateNewQuickcheckClientRequest {
    return true;
}

export function CreateNewQuickcheckClientRequestFromJSON(json: any): CreateNewQuickcheckClientRequest {
    return CreateNewQuickcheckClientRequestFromJSONTyped(json, false);
}

export function CreateNewQuickcheckClientRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateNewQuickcheckClientRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'company': json['company'] == null ? undefined : json['company'],
        'email': json['email'] == null ? undefined : json['email'],
        'serviceproviderUUID': json['serviceproviderUUID'] == null ? undefined : json['serviceproviderUUID'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'turnstileToken': json['turnstileToken'] == null ? undefined : json['turnstileToken'],
    };
}

export function CreateNewQuickcheckClientRequestToJSON(json: any): CreateNewQuickcheckClientRequest {
    return CreateNewQuickcheckClientRequestToJSONTyped(json, false);
}

export function CreateNewQuickcheckClientRequestToJSONTyped(value?: CreateNewQuickcheckClientRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'company': value['company'],
        'email': value['email'],
        'serviceproviderUUID': value['serviceproviderUUID'],
        'phone': value['phone'],
        'turnstileToken': value['turnstileToken'],
    };
}

